import React from 'react';
import { VerificatieBerekeningScore } from './VerificatieBerekeningScore';

export function VerificatieBerekeningScoreLabel(props: { score: number | undefined | null | string }) {
    if (props.score === null || props.score === undefined) {
        return null;
    }
    if (props.score.toString() === 'U') {
        return (
            <span className="label label-unknown p5 fs11" style={{ color: '#FFFFFF' }}>
                Onbekend
            </span>
        );
    } else if (props.score.toString() === VerificatieBerekeningScore.Voldoet) {
        return (
            <span className="label label-excellent p5 fs11" style={{ color: '#FFFFFF' }}>
                Voldoet
            </span>
        );
    }
    return (
        <span className="label label-bad p5 fs11" style={{ color: '#FFFFFF' }}>
            Voldoet niet
        </span>
    );
}
